import { BONDS_STORE_NAME } from '@/creditflowresearch/application/Bonds/constants';
import TwoLevelList from '@framework/ui/Organisms/Filters/FiltersPanel/TwoLevelList/TwoLevelList';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useCheckboxerContext } from '@framework/ui/Organisms/Filters/Checkboxer/CheckboxerContext';

const TwoLevelListContainer = (props) => {
  const { filterName } = props;
  const { getFiltersByFilterName } = useFiltersContext();
  const { checkboxes, getCheckboxChildren } = useCheckboxerContext();
  const filters = getFiltersByFilterName(BONDS_STORE_NAME, filterName) || [];

  return (
    <TwoLevelList
      { ...props }
      filters={ filters }
      checkboxes={ checkboxes }
      getCheckboxChildren={ getCheckboxChildren }
    />
  );
};

export default TwoLevelListContainer;
